import _ from 'lodash';

import React from 'react';

import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {MODALS} from 'ducks/allocations';

import {AddOutOfServiceReasonForm, Buttons} from './components';

import {fetchAllocationStatistics, fetchAllocations} from 'ducks/allocations';

import './styles.css';

class OutOfServiceReasonModal extends React.Component<any> {
  triggerSubmit = () => this.props.submit('addOutOfServiceReason');
  getExtraActions = () => {
    const {locationRef} = this.props.data;
    return [
      ...this.props.closeModalExtraActions,
      () => fetchAllocations({locationRef}),
      () => fetchAllocationStatistics({locationRef})
    ];
  };
  render() {
    const {
      locationRef,
      roomId,
      cleaningStatus,
      form: {submitting}
    } = this.props.data;

    const {closeModal} = this.props;
    return (
      <Modal
        className="OutOfServiceReasonModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={closeModal}>
        <Modal.Header heading="Out off service reason" />
        <Modal.Body>
          <AddOutOfServiceReasonForm
            locationRef={locationRef}
            roomId={roomId}
            getExtraActions={this.getExtraActions}
            cleaningStatus={cleaningStatus}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            submitting={submitting}
            closeModal={closeModal}
            triggerSubmit={this.triggerSubmit}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = state => {
  return {
    form: {
      submitting: isSubmitting('addOutOfServiceReason')(state)
    }
  };
};

const mapDispatchToProps = {
  submit
};

export default connect()(
  withModal(
    MODALS.OUT_OF_SERVICE_REASON,
    mapStateToModalData,
    mapDispatchToProps
  )(OutOfServiceReasonModal)
);
